import React, { useState } from 'react';
import '../../assets/css/contact/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Full name is required';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }
    
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    
    if (Object.keys(newErrors).length === 0) {
      console.log('Form submitted:', formData);
      setSubmitted(true);
      
      setTimeout(() => {
        setFormData({
          fullName: '',
          email: '',
          message: ''
        });
        setSubmitted(false);
      }, 3000);
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <div className="ct-contact-page-wrapper">
      <div className="ct-contact-container">
        <div className="ct-contact-content">
          {/* Left Side - Contact Information */}
          <div className="ct-contact-left-side">
            <div className="ct-contact-header">
              <h1 className="ct-contact-title">Contact Us</h1>
              <p className="ct-contact-subtitle">
                Have questions about CircleHub? Need technical support or want to collaborate? 
                We're here to help you succeed in your learning journey. Reach out to us anytime!
              </p>
            </div>

            <div className="ct-contact-info-list">
              {/* Address */}
              <div className="ct-contact-info-item">
                <div className="ct-info-icon-wrapper">
                  <i className="fas fa-home"></i>
                </div>
                <div className="ct-info-text">
                  <h3>Address</h3>
                  <p>University Road, Lahore</p>
                  <p>Punjab, Pakistan 54000</p>
                </div>
              </div>

              {/* Phone */}
              <div className="ct-contact-info-item">
                <div className="ct-info-icon-wrapper">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div className="ct-info-text">
                  <h3>Phone</h3>
                  <p>+92 300 1234567</p>
                </div>
              </div>

              {/* Email */}
              <div className="ct-contact-info-item">
                <div className="ct-info-icon-wrapper">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="ct-info-text">
                  <h3>Email</h3>
                  <p>support@circlehub.com</p>
                </div>
              </div>
            </div>

            {/* Social Media Icons */}
            <div className="ct-social-media-icons">
              <a href="#" className="ct-social-icon-link">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="ct-social-icon-link">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="ct-social-icon-link">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="ct-social-icon-link">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className="ct-contact-right-side">
            <div className="ct-contact-form-card">
              <h2 className="ct-form-card-title">Send Message</h2>
              
              {submitted && (
                <div className="ct-success-alert">
                  <i className="fas fa-check-circle"></i>
                  <span>Thank you! Your message has been sent successfully.</span>
                </div>
              )}

              <form onSubmit={handleSubmit} className="ct-message-form">
                {/* Full Name */}
                <div className="ct-form-field">
                  <input
                    type="text"
                    className={`ct-form-input ${errors.fullName ? 'ct-error' : ''}`}
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="Full Name"
                  />
                  {errors.fullName && (
                    <span className="ct-error-message">{errors.fullName}</span>
                  )}
                </div>

                {/* Email */}
                <div className="ct-form-field">
                  <input
                    type="email"
                    className={`ct-form-input ${errors.email ? 'ct-error' : ''}`}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email"
                  />
                  {errors.email && (
                    <span className="ct-error-message">{errors.email}</span>
                  )}
                </div>

                {/* Message */}
                <div className="ct-form-field">
                  <textarea
                    className={`ct-form-input ct-form-textarea ${errors.message ? 'ct-error' : ''}`}
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Type your Message..."
                    rows="5"
                  ></textarea>
                  {errors.message && (
                    <span className="ct-error-message">{errors.message}</span>
                  )}
                </div>

                {/* Submit Button */}
                <button type="submit" className="ct-submit-button">
                  Send
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;